import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {BackgroundImageControlLabels} from '../../BackgroundImageControlLabels';
import {StructureBuiltInControl} from '../StructureBuiltInControl';

export abstract class StructureBackgroundImageBuiltInControl extends StructureBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.STRUCTURE].IMAGE_CONTAINER;
  }

  public getLabels(): BackgroundImageControlLabels | undefined {
    return undefined;
  }
}
